import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pedidos-globales',
  templateUrl: './pedidos-globales.component.html',
  styleUrls: ['./pedidos-globales.component.css']
})
export class PedidosGlobalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
